import { useEffect, useLayoutEffect, useRef } from "react";

// Invisible, selectable text positioned over the page image (enables select → listen).
export const TextLayer = ({ lines, height, highlight }) => {
  const ref = useRef();

  useEffect(() => {
    const el = ref.current;
    // Mouse on actual words selects text; touches and empty areas go to the page-curl engine.
    const stop = (e) => { if (e.target !== el) e.stopPropagation(); };
    el.addEventListener("mousedown", stop);
    return () => el.removeEventListener("mousedown", stop);
  }, []);

  useLayoutEffect(() => {
    ref.current.querySelectorAll("span").forEach((s) => {
      s.style.transform = "";
      const target = s.parentElement.clientWidth * (Number(s.dataset.w) / 100);
      if (s.scrollWidth) s.style.transform = `scaleX(${target / s.scrollWidth})`;
    });
  }, [lines, height]);

  return (
    <div ref={ref} className="text-layer" data-testid="text-layer">
      {lines.map(([x, y, w, h, t], i) => (
        <span key={i} data-w={w} className={highlight?.has(i) ? "read-hl" : ""} data-testid={highlight?.has(i) ? "read-highlight" : undefined} style={{ left: `${x}%`, top: `${y}%`, fontSize: `${(h / 100) * height * 0.88}px` }}>{`${t} `}</span>
      ))}
    </div>
  );
};
